import React from 'react';
import UserContext from './context';

const injectUser = (Component) => (props) => (
  <UserContext.Consumer>
    {({ authUser, isAuthReady }) => (
      <Component {...props} authUser={authUser} isAuthReady={isAuthReady} />
    )}
  </UserContext.Consumer>
);

export default injectUser;
